import React from "react";
import { Route, Switch } from "react-router-dom";

import { Routing } from "../../../../core/routing";
import { ROUTES } from "../../../../routes";
import { ExpenseCreatePage } from "./create_page";
import { ExpenseDetailPage } from "./detail_page";
import { ExpenseEditPage } from "./edit_page";
import { ExpenseListPage } from "./list_page";

export const ExpenseMainPage: React.FC = () => {
  return (
    <Switch>
      <Route path={ROUTES.expense} exact>
        <ExpenseListPage />
      </Route>

      <Route path={Routing.generateCreateRoute(ROUTES.expense)}>
        <ExpenseCreatePage />
      </Route>

      <Route path={Routing.generateEditRoute(ROUTES.expense)}>
        <ExpenseEditPage />
      </Route>

      <Route path={Routing.generateDetailRoute(ROUTES.expense)}>
        <ExpenseDetailPage />
      </Route>
    </Switch>
  );
};
